import Typography from '@platform-ui-common/components/Typography/index.js';
import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import { StatusBlockSection } from '@platform-ui/application/hooks/useApplicationStatusBlocks/getStatusBlocks.js';
import useApplicationStatusBlocks from '@platform-ui/application/hooks/useApplicationStatusBlocks/index.js';
import ApplicationBlock from './ApplicationBlock.js';
import Panel from './Panel.js';

export default function OtherPrograms(): JSX.Element {
  const program = useProgram();
  const blocks = useApplicationStatusBlocks()[StatusBlockSection.AvailablePrograms].filter(
    ({ id }) => id !== program?.id,
  );
  if (blocks.length === 0) return null;

  return (
    <Panel title="Other open programs">
      <Typography variant="body">
        Submit a new application to a different program. Your eligibility will be determined after
        you apply.
      </Typography>
      {blocks.map((block) => (
        <ApplicationBlock key={block.id} {...block} />
      ))}
    </Panel>
  );
}
